import { render, staticRenderFns } from "./VPrescriptionTableHeader.vue?vue&type=template&id=ead08af2&"
import script from "./VPrescriptionTableHeader.vue?vue&type=script&lang=ts&setup=true&"
export * from "./VPrescriptionTableHeader.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./VPrescriptionTableHeader.vue?vue&type=style&index=0&id=ead08af2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports